import React from 'react';
import {DatePollInfo} from "../../models/DatePollInfo";
import {Grid} from "@mui/material";
import {getShortenDateWithDayOfWeek} from "../../utils/Utils";

interface BestDateItemProps {
    datePollInfo: DatePollInfo;
}

export const BestDateItem: React.FC<BestDateItemProps> = ({ datePollInfo }) => {
    return (
        <Grid container item justifyContent={"space-between"}>
            <Grid item>
                <span>{getShortenDateWithDayOfWeek(datePollInfo.date)}</span>
            </Grid>
            <Grid item>
                <span className={"highlight-text"}
                      style={{fontSize: "12px"}}>되는 날 {datePollInfo.getAttendCount()}</span>
                <span style={{fontWeight: 400}}> · </span>
                <span style={{fontSize: "12px", color: '#555'}}>확인 필요 {datePollInfo.getNotSureCount()}</span>
                {/*<span style={{fontWeight: 400}}> · </span>*/}
                {/*<span style={{fontSize: "12px"}}>안되는 날 {datePollInfo.getAbsentCount()}</span>*/}
            </Grid>
        </Grid>
    );
}